export default "__VITE_ASSET__khcgn63V__"